export default __webpack_public_path__ + "static/media/fulls-screen.2254f820.svg";